import React from 'react';
import { useSelector } from 'react-redux';
import { Menu, Command } from 'lucide-react';
import UserAvatar from '../Common/UserAvatar';
import { getPlanDetails } from '../../utils/planUtils';

const AdminNavbar = ({ activeView, setIsMobileOpen }) => {
    const { user } = useSelector((state) => state.user);
    const getViewTitle = () => {
        switch (activeView) {
            case 'admin': return 'Insights & Network';
            case 'users': return 'Entity Management';
            default: return 'Management Console';
        }
    };

    return (
        <header className="h-24 px-10 flex items-center justify-between sticky top-0 z-30 bg-white/60 backdrop-blur-xl border-b border-slate-200/40">
            {/* Breadcrumb Area */}
            <div className="flex items-center gap-10">
                <button
                    onClick={() => setIsMobileOpen(true)}
                    className="lg:hidden p-3 bg-white border border-slate-200 rounded-xl text-slate-600 hover:bg-slate-50 transition-colors shadow-sm"
                >
                    <Menu className="w-5 h-5" />
                </button>

                <div className="hidden md:flex items-center">
                    <div className="flex items-center space-x-3">
                        <div className="flex items-center justify-center w-8 h-8 rounded-lg bg-slate-900 text-white shadow-lg shadow-slate-200">
                            <Command className="w-4 h-4" />
                        </div>
                        <div className="h-4 w-px bg-slate-200 mx-1" />
                        <div className="flex flex-col">
                            <h2 className="text-xs font-black text-slate-400 uppercase tracking-widest">{activeView}</h2>
                            <h3 className="text-lg font-black text-slate-900 tracking-tight leading-none mt-0.5">{getViewTitle()}</h3>
                        </div>
                    </div>
                </div>
            </div>

            {/* Profile Section */}
            <div className="flex items-center gap-6">
                <div className="flex flex-col items-end hidden sm:flex">
                    <p className="text-sm font-black text-slate-900 leading-none">{user?.full_name || 'Admin'}</p>
                    <div className="flex items-center gap-2 mt-1">
                        <span className={`text-[8px] font-black uppercase tracking-widest px-1.5 py-0.5 rounded-md border ${getPlanDetails(useSelector(state => state.payment).subscription?.plan?.name, useSelector(state => state.payment).subscription?.status).colors}`}>
                            {getPlanDetails(useSelector(state => state.payment).subscription?.plan?.name, useSelector(state => state.payment).subscription?.status).label}
                        </span>
                        <p className="text-[9px] font-bold text-slate-400 uppercase tracking-widest">System Admin</p>
                    </div>
                </div>
                <UserAvatar 
                    user={user} 
                    size="md" 
                    indicator={true}
                    className="cursor-pointer hover:scale-105 transition-transform"
                />
            </div>
        </header>
    );
};

export default AdminNavbar;
